<template>
  <div>
    <v-row>
      <v-col>
        <h3>Form D Filters</h3>
      </v-col>
      <v-col class="text-right">
        <v-btn variant="text">Clear all</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import { mapStoreState, mapStoreGetters } from '@/store/helpers'
import { mapFields } from '@/store/helpers'

// Mixins
import FormattersMixin from '@/mixins/formatters'
import cloneDeep from 'lodash/cloneDeep'

export default {
  mixins: [FormattersMixin],

  data() {
    return {
      filters: [
        {
          identifier: 'industry_group_type',
          title: 'Industry Group',
          items: [
            { id: 1, description: 'Commercial Banking' },
            { id: 2, description: 'Insurance' },
            { id: 3, description: 'Investing' },
            { id: 4, description: 'Investment Banking' },
            { id: 5, description: 'Pooled Investment Fund' },
            { id: 6, description: 'Other Banking & Financial Services' },
            { id: 7, description: 'Business Services' },
            { id: 8, description: 'Electric Utilities' },
            { id: 9, description: 'Energy Conservation' },
            { id: 10, description: 'Coal Mining' },
            { id: 11, description: 'Environmental Services' },
            { id: 12, description: 'Oil & Gas' },
            { id: 13, description: 'Other Energy' },
            { id: 14, description: 'Biotechnology' },
            { id: 15, description: 'Health Insurance' },
            { id: 16, description: 'Hospitals & Physicians' },
            { id: 17, description: 'Pharmaceuticals' },
            { id: 18, description: 'Other Health Care' },
            { id: 19, description: 'Commercial' },
            { id: 20, description: 'Construction' },
            { id: 21, description: 'REITS & Finance' },
            { id: 22, description: 'Residential' },
            { id: 23, description: 'Other Real Estate' },
            { id: 24, description: 'Retailing' },
            { id: 25, description: 'Restaurants' },
            { id: 26, description: 'Computers' },
            { id: 27, description: 'Telecommunications' },
            { id: 28, description: 'Other Technology' },
            { id: 29, description: 'Airlines & Airports' },
            { id: 30, description: 'Lodging & Conventions' },
            { id: 31, description: 'Tourism & Travel Services' },
            { id: 32, description: 'Other Travel' },
            { id: 33, description: 'Manufacturing' },
            { id: 34, description: 'Other' }
          ]
        },
        {
          identifier: 'investment_fund_type',
          title: 'Investment Fund Type',
          items: [
            { id: 1, description: 'Hedge Fund' },
            { id: 2, description: 'Private Equity Fund' },
            { id: 3, description: 'Venture Capital Fund' },
            { id: 4, description: 'Other Investment Fund' }
          ]
        },
        {
          identifier: 'revenue_range',
          title: 'Revenue Range',
          items: [
            { id: 1, description: 'No Revenues' },
            { id: 2, description: '$1 - $1 million' },
            { id: 3, description: '$1 million - $5 million' },
            { id: 4, description: '$5 million - $25 million' },
            { id: 5, description: '$25 million - $100 million' },
            { id: 6, description: 'Over $100 million' },
            { id: 7, description: 'Decline to Disclose' },
            { id: 8, description: 'Not Applicable' }
          ]
        },
        {
          identifier: 'aggregate_net_asset_value_range',
          title: 'Aggregate Net Asset Value Range',
          items: [
            { id: 1, description: 'No Aggregate Net Asset Value' },
            { id: 2, description: '$1 - $5,000,000' },
            { id: 3, description: '$5,000,001 - $25,000,000' },
            { id: 4, description: '$25,000,001 - $50,000,000' },
            { id: 5, description: '$50,000,001 - $100,000,000' },
            { id: 6, description: 'Over $100,000,000' },
            { id: 7, description: 'Decline to Disclose' },
            { id: 8, description: 'Not Applicable' }
          ]
        },
        {
          identifier: 'federal_exemption_types',
          title: 'Federal Exemptions and Exclusions Claimed',
          items: [
            { id: 1, description: 'Rule 504(b)(1) (not (i), (ii) or (iii))' },
            { id: 2, description: 'Rule 504(b)(1)(i)' },
            { id: 3, description: 'Rule 504(b)(1)(ii)' },
            { id: 4, description: 'Rule 504(b)(1)(iii)' },
            { id: 5, description: 'Rule 505' },
            { id: 6, description: 'Rule 506' },
            { id: 22, description: 'Rule 506(b)' },
            { id: 23, description: 'Rule 506(c)' },
            { id: 7, description: 'Securities Act Section 4(5)' },
            { id: 8, description: 'Section 3(c)(1)' },
            { id: 9, description: 'Section 3(c)(2)' },
            { id: 10, description: 'Section 3(c)(3)' },
            { id: 11, description: 'Section 3(c)(4)' },
            { id: 12, description: 'Section 3(c)(5)' },
            { id: 13, description: 'Section 3(c)(6)' },
            { id: 14, description: 'Section 3(c)(7)' },
            { id: 15, description: 'Section 3(c)(9)' },
            { id: 16, description: 'Section 3(c)(10)' },
            { id: 17, description: 'Section 3(c)(11)' },
            { id: 18, description: 'Section 3(c)(12)' },
            { id: 19, description: 'Section 3(c)(13)' },
            { id: 20, description: 'Section 3(c)(14)' },
            { id: 21, description: 'Investment Company Act Section 3(c)' }
          ]
        },
        {
          identifier: 'type_of_filing',
          title: 'Filing',
          items: [
            { id: 1, description: 'New Notice' },
            { id: 2, description: 'Amendment' }
          ]
        },
        {
          identifier: 'duration_of_offering_more_than_one_year',
          title: 'Does issuer intend this offering to last more than one year?',
          items: [
            { id: 1, description: 'Yes' },
            { id: 2, description: 'No' }
          ]
        },
        {
          identifier: 'item9',
          title: 'Types of Securities Offered',
          items: [
            { id: 1, description: 'Equity' },
            { id: 2, description: 'Debt' },
            { id: 3, description: 'Option, Warrant or Other Right to Acquire Another Security' },
            {
              id: 4,
              description:
                'Security to be Acquired Upon Exercise of Option, Warrant or Other Right to Acquire Security'
            },
            { id: 5, description: 'Pooled Investment Fund Interests' },
            { id: 6, description: 'Tenant-in-Common Securities' },
            { id: 7, description: 'Mineral Property Securities' },
            { id: 8, description: 'Other' }
          ]
        },
        {
          identifier: 'is_business_combination_transaction',
          title: 'Is offering being made in connection with a business combination transaction?',
          items: [
            { id: 1, description: 'Yes' },
            { id: 2, description: 'No' }
          ]
        },
        {
          identifier: 'minimum_investment_accepted',
          title: 'Minimum Investment accepted from any outside investor',
          type: 'number_range'
        },
        {
          identifier: 'total_offering_amount',
          title: 'Total Offering Amount',
          type: 'number_range',
          items: [{ id: 1, description: 'Indefinite' }]
        },
        {
          identifier: 'issuer_state',
          title: 'State Issuer Located',
          items: [
            ...useWwStore().states.map(state => ({
              id: state.state,
              description: state.state
            }))
          ]
        },
        {
          identifier: 'solicitation_state',
          title: 'States of Solicitation',
          items: [
            ...useWwStore().states.map(state => ({
              id: state.state,
              description: state.state
            }))
          ]
        }
      ]
    }
  },

  computed: {
    ...mapFields({
      criteria: 'app.trendFinderCriteria'
    })
  },

  watch: {},

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.filer-name-cell-min-width {
  min-width: 300px;
}
</style>
